import React from "react";
import { Route, Switch } from "react-router-dom";
import asyncComponent from "util/asyncComponent";

const Role = ({ match }) => (
  <div className="app-wrapper">
    <Switch>
      <Route
        path={`${match.url}/add`}
        component={asyncComponent(() => import("./routes/AddRole"))}
      />
      <Route
        path={`${match.url}/edit/:id`}
        component={asyncComponent(() => import("./routes/AddRole"))}
      />
      <Route
        path={`${match.url}/list`}
        component={asyncComponent(() => import("./routes/RoleList"))}
      />
    </Switch>
  </div>
);

export default Role;
